<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="500px"
    center
    append-to-body
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="120px"
      size="small"
    >
      <el-form-item label="保险公司名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入保险公司名称" maxlength="100" />
      </el-form-item>
      
      <el-form-item label="保险公司类型" prop="type">
        <el-select v-model="form.type" placeholder="请选择保险公司类型" style="width: 100%">
          <el-option label="通用保险公司" :value="1" />
          <el-option label="货运年保超市专用保险公司" :value="2" />
        </el-select>
      </el-form-item>
      
      <el-form-item label="状态" prop="disabled">
        <el-select v-model="form.disabled" placeholder="请选择状态" style="width: 100%">
          <el-option label="启用" :value="false" />
          <el-option label="禁用" :value="true" />
        </el-select>
      </el-form-item>
      
      <el-form-item label="保险公司邮箱" prop="email_address">
        <el-input v-model="form.email_address" placeholder="请输入保险公司邮箱" maxlength="100" />
      </el-form-item>
      
      <el-form-item label="公司Logo" prop="logo_url">
        <el-upload
          class="logo-uploader"
          :action="uploadUrl"
          :headers="uploadHeaders"
          :show-file-list="false"
          :on-success="handleLogoSuccess"
          :before-upload="beforeLogoUpload"
        >
          <img v-if="form.logo_url" :src="form.logo_url" class="logo" />
          <i v-else class="el-icon-plus logo-uploader-icon"></i>
        </el-upload>
        <div style="margin-top: 5px; color: #999; font-size: 12px;">
          支持 jpg、png 格式，建议尺寸 200x200 像素
        </div>
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSave">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveInsuranceCompany } from '@/api/product'
import Cookies from 'js-cookie'

export default {
  name: 'InsuranceCompanyEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        id: null,
        name: '',
        type: '',
        disabled: false,
        email_address: '',
        logo_url: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入保险公司名称', trigger: 'blur' },
          { max: 100, message: '保险公司名称不能超过100个字符', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择保险公司类型', trigger: 'change' }
        ],
        disabled: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        email_address: [
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      },
      uploadUrl: process.env.VUE_APP_BASE_API + '/v1/admin/cmn/upload',
      uploadHeaders: {
        'Authorization': 'Bearer ' + Cookies.get('jubao_admin'),
        'AppKey': 'BpLnfgDs'
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    },
    formData: {
      handler(val) {
        if (val && Object.keys(val).length > 0) {
          this.form = { ...val }
        } else {
          this.resetForm()
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    resetForm() {
      this.form = {
        id: null,
        name: '',
        type: '',
        disabled: false,
        email_address: '',
        logo_url: ''
      }
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    
    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },
    
    async handleSave() {
      try {
        await this.$refs.form.validate()
        
        const data = { ...this.form }
        if (!data.id) {
          delete data.id
        }
        
        const res = await saveInsuranceCompany(data)
        if (res && res.err_code === 0) {
          this.$message.success('保存成功')
          this.$emit('save')
          this.handleClose()
        } else {
          this.$message.error(res.err_msg || '保存失败')
        }
      } catch (error) {
        console.error('保存失败:', error)
      }
    },
    
    beforeLogoUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      
      if (!isJPG) {
        this.$message.error('只能上传 JPG/PNG 格式的图片!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }
      return true
    },
    
    handleLogoSuccess(res) {
      if (res && res.err_code === 0) {
        this.form.logo_url = res.data
        this.$message.success('Logo上传成功')
      } else {
        this.$message.error('Logo上传失败')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.logo-uploader {
  .logo {
    width: 100px;
    height: 100px;
    display: block;
    border-radius: 6px;
  }
}

/deep/ .logo-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  
  &:hover {
    border-color: #409EFF;
  }
  
  .logo-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
}
</style>